import { LoadCssResolver, LoadScriptResolver } from '@b2b/common/resolvers';
import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { ProgramsCalendarEventView } from './event/event';

export const ProgramsCalendarView = angular
  .module('acme.view.application.programs.calendar', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.directive.calendar',
    ProgramsCalendarEventView,
    'acme.view.application.programs.calendar.controllers',
  ])
  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const calendar = {
      name: 'application.programs.calendar',
      url: '/calendar',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'CalendarController',
          templateUrl: 'views/application/views/programs/calendar/calendar.tpl.html',
        },
      },
      resolve: {
        jqueryUI: LoadScriptResolver({ id: 'jquery-ui', url: '/assets/jquery-ui.custom.min.js' }),
        fullcalendar: LoadScriptResolver({ id: 'fullcalendar', url: '/assets/fullcalendar.js' }),
        istevenMultiselectCss: LoadCssResolver({ id: 'isteven-multi-select', url: '/assets/isteven-multi-select.css' }),
      },
    };

    $stateProvider.state(calendar);
  }).name;
